// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ViewModeColumnViewSettingsBuf } from '../interface/view-mode-column-view-settings-buf.js';
import { ViewModeDetailViewSettingsBuf } from '../interface/view-mode-detail-view-settings-buf.js';
import { ViewModeFilterBuf } from '../interface/view-mode-filter-buf.js';
import { ViewModeGalleryViewSettingsBuf } from '../interface/view-mode-gallery-view-settings-buf.js';
import { ViewModeGeneralSettingsBuf } from '../interface/view-mode-general-settings-buf.js';
import { ViewModeGroupBuf } from '../interface/view-mode-group-buf.js';
import { ViewModeShowBuf } from '../interface/view-mode-show-buf.js';
import { ViewModeSortBuf } from '../interface/view-mode-sort-buf.js';
import { ViewModeTableViewSettingsBuf } from '../interface/view-mode-table-view-settings-buf.js';
import { ViewModeType } from '../interface/view-mode-type.js';


/**
 * Represents the view mode settings for a particular folder view,
 * which might apply globally for a user, or be specific to a 
 * certain folder, or perhaps to other scopes such as a space.
 */
export class ViewModeSettingsBuf {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):ViewModeSettingsBuf {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsViewModeSettingsBuf(bb:flatbuffers.ByteBuffer, obj?:ViewModeSettingsBuf):ViewModeSettingsBuf {
  return (obj || new ViewModeSettingsBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsViewModeSettingsBuf(bb:flatbuffers.ByteBuffer, obj?:ViewModeSettingsBuf):ViewModeSettingsBuf {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new ViewModeSettingsBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

mode():ViewModeType {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : ViewModeType.Icon;
}

show(index: number, obj?:ViewModeShowBuf):ViewModeShowBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? (obj || new ViewModeShowBuf()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

showLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

sort(index: number, obj?:ViewModeSortBuf):ViewModeSortBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? (obj || new ViewModeSortBuf()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

sortLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

filter(index: number, obj?:ViewModeFilterBuf):ViewModeFilterBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? (obj || new ViewModeFilterBuf()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

filterLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

columnView(obj?:ViewModeColumnViewSettingsBuf):ViewModeColumnViewSettingsBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? (obj || new ViewModeColumnViewSettingsBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

detailView(obj?:ViewModeDetailViewSettingsBuf):ViewModeDetailViewSettingsBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? (obj || new ViewModeDetailViewSettingsBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

tableView(obj?:ViewModeTableViewSettingsBuf):ViewModeTableViewSettingsBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? (obj || new ViewModeTableViewSettingsBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

galleryView(obj?:ViewModeGalleryViewSettingsBuf):ViewModeGalleryViewSettingsBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 18);
  return offset ? (obj || new ViewModeGalleryViewSettingsBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

general(obj?:ViewModeGeneralSettingsBuf):ViewModeGeneralSettingsBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 20);
  return offset ? (obj || new ViewModeGeneralSettingsBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

group(obj?:ViewModeGroupBuf):ViewModeGroupBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 22);
  return offset ? (obj || new ViewModeGroupBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

static startViewModeSettingsBuf(builder:flatbuffers.Builder) {
  builder.startObject(10);
}

static addMode(builder:flatbuffers.Builder, mode:ViewModeType) {
  builder.addFieldInt8(0, mode, ViewModeType.Icon);
}

static addShow(builder:flatbuffers.Builder, showOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, showOffset, 0);
}

static createShowVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startShowVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addSort(builder:flatbuffers.Builder, sortOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, sortOffset, 0);
}

static createSortVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startSortVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addFilter(builder:flatbuffers.Builder, filterOffset:flatbuffers.Offset) {
  builder.addFieldOffset(3, filterOffset, 0);
}

static createFilterVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startFilterVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addColumnView(builder:flatbuffers.Builder, columnViewOffset:flatbuffers.Offset) {
  builder.addFieldOffset(4, columnViewOffset, 0);
}

static addDetailView(builder:flatbuffers.Builder, detailViewOffset:flatbuffers.Offset) {
  builder.addFieldOffset(5, detailViewOffset, 0);
}

static addTableView(builder:flatbuffers.Builder, tableViewOffset:flatbuffers.Offset) {
  builder.addFieldOffset(6, tableViewOffset, 0);
}

static addGalleryView(builder:flatbuffers.Builder, galleryViewOffset:flatbuffers.Offset) {
  builder.addFieldOffset(7, galleryViewOffset, 0);
}

static addGeneral(builder:flatbuffers.Builder, generalOffset:flatbuffers.Offset) {
  builder.addFieldOffset(8, generalOffset, 0);
}

static addGroup(builder:flatbuffers.Builder, groupOffset:flatbuffers.Offset) {
  builder.addFieldOffset(9, groupOffset, 0);
}

static endViewModeSettingsBuf(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

}
